module.exports = __webpack_public_path__ + "img/temp-todo.624bae4f.svg";